import { IContent } from '@src/interfaces/community';
import { devices, theme } from '@src/styles/theme';
import { bloodFormat, categoryFormat } from '@src/utils/community';
import { useRouter } from 'next/router';
import styled from 'styled-components';

type Props = {
  community: IContent | any; // 사연과 생활통합하기위해 any로 타입에러 체크
  isMobile?: boolean;
};

const Info = ({ community, isMobile }: Props) => {
  console.log(community, '필드명');

  const router = useRouter();
  console.log(router.pathname);

  return (
    <>
      {(router.pathname.startsWith('/community/donation') ||
        router.pathname.startsWith('/post')) && (
        <InfoWrap>
          <div>
            {community?.renewCount > 0 && (
              <InfoButton isExtention={true} isMobile={isMobile}>
                사연연장{community?.renewCount}회
              </InfoButton>
            )}
            <InfoButton isExtention={false} isMobile={isMobile}>
              {community?.patient?.bloodType?.abo}+
            </InfoButton>
            <InfoButton isExtention={false} isMobile={isMobile}>
              {bloodFormat(community?.bloodProduct)}
            </InfoButton>
          </div>
        </InfoWrap>
      )}
      {(router.pathname.startsWith('/community/board') ||
        router.pathname.startsWith('/blood-home')) && (
        <InfoWrap>
          <div>
            <InfoButton isExtention={false} isMobile={isMobile}>
              {categoryFormat(community?.category)}
            </InfoButton>
          </div>
        </InfoWrap>
      )}
    </>
  );
};

const InfoWrap = styled.div`
  button:not(:last-child) {
    margin-right: 8px;
  }
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const InfoButton = styled.button<{
  isExtention: boolean;
  isMobile?: boolean;
}>`
  background-color: ${({ theme, isExtention }) =>
    isExtention ? theme.commonColor.pink004 : theme.commonColor.gray002};
  padding: 6px 8px;
  color: ${({ theme, isExtention }) =>
    isExtention ? theme.commonColor.white : theme.commonColor.gray005};
  border-radius: 3px;
  font-size: 12px;

  /* media는 중복으로 되는데 위에서 아래일수록 덮어씌여진다. */
  @media ${devices.desktop} {
    ${({ isMobile }) =>
      isMobile ? `display: none;` : 'display: inline-block;'};
  }

  @media ${devices.tablet} {
    ${({ isMobile }) =>
      isMobile ? `display: inline-block;` : `display: none`};
  }
`;

export default Info;
